export default __webpack_public_path__ + "static/media/questsIcon.7e318d38.svg";